import * as marietta from '../../..';
import { EventDispatcher } from '../events';

export default class URLLoader extends EventDispatcher {
  public data: any;

  public load(request: marietta.webcad.flash.net.URLRequest): void {
    // $(function (): void {
    //   $.ajax({
    //     url: request.url,
    //     type: 'GET',
    //     dataType: 'html',
    //     timeout: 60000,
    //     error: (): void => {
    //       console.error('load error');
    //     },
    //     success: (text: any): void => {
    //       this.data = text;

    //       var evt: marietta.webcad.flash.events.Event = new marietta.webcad.flash.events.Event(marietta.webcad.flash.events.Event.COMPLETE);
    //       this.dispatchEvent(evt);
    //     },
    //   });
    // });

    fetch(request.url)
      .then((response) => response.text())
      .then((body) => {
        // console.log(body);

        this.data = body;
        const evt: marietta.webcad.flash.events.Event = new marietta.webcad.flash.events.Event(marietta.webcad.flash.events.Event.COMPLETE);
        this.dispatchEvent(evt);
      });
  }
}
